// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'e98edf44-ad4f-4721-a1d4-a1b2f4f54b9a',
      type: 'Sprite',
      name: 'closeArea',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'square_64',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1'
        }
      }
    },
    {
      id: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      type: 'Container',
      name: 'popup',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'dd17f55f-9e4a-4dab-aece-46a115d0d291',
      type: 'Container',
      name: 'content',
      className: '',
      x: 0,
      y: -300,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d'
    },
    {
      id: '119329f5-7913-49e4-b098-bb3fda4d406e',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -300,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 600,
      height: 250,
      leftWidth: 44,
      topHeight: 44,
      rightWidth: 44,
      bottomHeight: 59,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Ad_Locked_Tiles_Reminder_Background_9Slice_44x44x44x59',
      parent: 'dd17f55f-9e4a-4dab-aece-46a115d0d291'
    },
    {
      id: 'aa0a051a-5171-4edb-9249-196ad79b648a',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 46,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      text: 'Unlock an extra space?',
      localize: true,
      maxWidth: 500,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#8D2400',
        stroke: '#8D2400',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'dd17f55f-9e4a-4dab-aece-46a115d0d291',
      stateByName: {
        unclaimable: {
          visible: false
        },
        inProgressAnimation: {
          visible: false
        },
        inClaimAnimation: {
          visible: false
        },
        unclaimable_tier: {
          visible: false
        },
        claimable_tier: {
          x: 147,
          style: {
            fontSize: 36
          },
          y: -168,
          maxWidth: 100
        },
        claimable_lastChance: {
          x: 235,
          visible: false,
          maxWidth: 115
        }
      }
    },
    {
      id: '0610aa45-ecb7-47fd-97b0-1a90972afff9',
      type: 'Layout',
      name: 'unlockButton',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 145,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: 'dd17f55f-9e4a-4dab-aece-46a115d0d291',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        claimable: {
          visible: false
        },
        unclaimable: {
          visible: true
        },
        inProgressAnimation: {
          visible: false
        },
        inClaimAnimation: {
          visible: false
        },
        unclaimable_tier: {
          y: 530
        },
        claimable_tier: {
          visible: false
        },
        claimable_lastChance: {
          visible: false
        }
      }
    },
    {
      id: '8ecc9204-964f-4bd0-ad7b-0375174db06c',
      type: 'Text',
      name: 'coinAmount',
      className: '',
      x: 35,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '300',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x00700c',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0610aa45-ecb7-47fd-97b0-1a90972afff9'
    },
    {
      id: '37e6c49f-cd35-48b9-8f9b-3ce8f4d6b7e4',
      type: 'Sprite',
      name: '',
      className: '',
      x: -64,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Coin_Icon',
      parent: '0610aa45-ecb7-47fd-97b0-1a90972afff9'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  animations: [
    {
      id: '85f1250b-ac27-47e6-acaa-651c51d11b4f',
      name: 'Appear',
      playingSpeed: 1,
      totalDuration: 350,
      blocks: [
        {
          id: 'cd515f0f-ef96-46c3-b118-9a8fdaaa1ce7',
          type: 'Setter',
          name: 'setPos_content',
          track: 1,
          target: {
            scale: {},
            y: 0
          },
          startAt: 0,
          sourceName: 'content',
          disabled: false
        },
        {
          id: 'd4754863-7a32-4542-b1bf-f1d4c771808e',
          type: 'Tween',
          name: 'tweenPos_content',
          duration: 150,
          track: 2,
          target: {
            y: -300
          },
          startAt: 1,
          sourceName: 'content',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '77ea8674-9260-4baa-b97e-84f0e3363cb1',
          type: 'Tween',
          name: 'tweenScale_content',
          duration: 100,
          track: 3,
          target: {
            scale: {
              x: 1.02,
              y: 0.98
            }
          },
          startAt: 141,
          sourceName: 'content',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '65fe0071-01ca-481f-bd52-61b87c2100a0',
          type: 'Tween',
          name: 'tweenScale2_content',
          duration: 100,
          track: 3,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 241,
          sourceName: 'content',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: '3dcaf3ee-6867-416f-9bad-a0efe2d99117',
      name: 'Disappear',
      playingSpeed: 1,
      totalDuration: 150,
      blocks: [
        {
          id: 'cd515f0f-ef96-46c3-b118-9a8fdaaa1ce7',
          type: 'Setter',
          name: 'setPos_content',
          track: 1,
          target: {
            scale: {},
            y: -300
          },
          startAt: 0,
          sourceName: 'content',
          disabled: false
        },
        {
          id: 'd4754863-7a32-4542-b1bf-f1d4c771808e',
          type: 'Tween',
          name: 'tweenPos_content',
          duration: 150,
          track: 2,
          target: {
            y: 0
          },
          startAt: 1,
          sourceName: 'content',
          easing: 'SinusoidalIn',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class UnlockBlockerPopupLayout {
  static raw = raw;
  root!: Container;
  closeArea!: Sprite & { data: typeof raw['list'][1]['data'] };
  popup!: Container;
  content!: Container;
  unlockButton!: ButtonExtraLargeLayout & { data: typeof raw['list'][6]['data'] };
  coinAmount!: Text;
  dynamicProps_SPL!: (Sprite & { data: typeof raw['list'][1]['data'] })[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Appear {
  Layout: {
    content: object;
  };

  BlockTypeByName: {
    setPos_content: object;
    tweenPos_content: object;
    tweenScale_content: object;
    tweenScale2_content: object;
  };

  flowData = raw.animations[0];
}

export abstract class Disappear {
  Layout: {
    content: object;
  };

  BlockTypeByName: {
    setPos_content: object;
    tweenPos_content: object;
  };

  flowData = raw.animations[1];
}
